export default {
    name: "SalesPersonHeader",
    setup(){
        
    }
}